/** Mirrors `display-session.ts` exactly, with its own storage key so pairing as a display and pairing as a controller in the same browser don't clobber each other. */
const STORAGE_KEY = "stagvista.control-session";

export interface ControlSession {
  readonly role: "operator" | "assistant" | "viewer";
  readonly token: string;
  readonly expiresAt: number;
}

export function loadControlSession(): ControlSession | null {
  const raw = window.localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as ControlSession;
    if (parsed.expiresAt <= Date.now()) {
      window.localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function storeControlSession(session: ControlSession): void {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
}

export function clearControlSession(): void {
  window.localStorage.removeItem(STORAGE_KEY);
}
